// extracted by mini-css-extract-plugin
module.exports = {"action-link":"style_action-link__1IRSE","total-font":"style_total-font__1fheO"};